import { render } from "./App.vue?vue&type=template&id=1f5e3732"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1f5e3732&lang=scss"

import exportComponent from "C:\\Users\\bene\\Development\\machina_eX\\LayersOfLife\\bundesanstalt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__